import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const endpointFields = { url: true, enabled: true, updatedAt: true } as const

export const GQL_WEBHOOK_ENDPOINT = typedGql('query', { scalars })({
  webhookEndpoint: endpointFields,
})

export const GQL_WEBHOOK_DELIVERIES = typedGql('query', { scalars })({
  webhookDeliveries: {
    id: true,
    event: true,
    status: true,
    attempts: true,
    lastStatusCode: true,
    lastError: true,
    createdAt: true,
    nextAttemptAt: true,
  },
})

export const GQL_SAVE_WEBHOOK_ENDPOINT = typedGql('mutation', { scalars })({
  saveWebhookEndpoint: [
    { input: $('input', 'SaveWebhookEndpointInput!') },
    { endpoint: endpointFields, secret: true },
  ],
})

export const GQL_REGENERATE_WEBHOOK_SECRET = typedGql('mutation')({
  regenerateWebhookSecret: true,
})

export const GQL_SEND_WEBHOOK_TEST = typedGql('mutation')({
  sendWebhookTest: true,
})
